export const creditInfo = [
  {
    title: "What is credit?",
    content: "Credit is your ability to access goods and services with the promise to pay later. Building trust and means you can borrow at better rates and save money. Start building today!"
  },
  {
    title: "Why your credit score matters",
    content: "Your credit score can impact everything from loan approval to job opportunities. A good score (700+) opens doors, while a low score can limit options. Are you checking yours regularly?"
  },
  {
    title: "The three credit bureaus",
    content: "Did you know? There are three major credit bureaus: Equifax, Experian, and TransUnion. They keep track of your credit history and each may have slightly different information. It's important to check all three annually!"
  },
  {
    title: "Types of credit",
    content: "1. Revolving Credit (e.g. credit cards) 2. Installment Loans (e.g. car loans, student loans) 3. Open Credit (e.g. utility bills). Understanding these helps you manage your finances better!"
  },
  {
    title: "Building credit from scratch",
    content: "New to credit? Start small! Get a secured credit card, make timely payments, and keep your credit utilization low (30%+). Just trust is a strong credit history built!"
  },
  {
    title: "The impact of late payments",
    content: "Late Payments can hurt your credit score significantly! Paying bills on time is one of the most important steps to maintaining good credit. Set reminders or automatic payments to stay on track!"
  },
  {
    title: "What affects your credit score?",
    content: "5 key factors influence your score: 1. Payment History (35%) 2. Amounts Owed (30%) 3. Length of Credit History (15%) 4. New Credit (10%) 5. Types of Credit Used (10%). Focus on the big factors to boost your score!"
  },
  {
    title: "Credit utilization rule",
    content: "Credit Utilization is the percentage of your available credit that you're using. Experts recommend keeping it under 30%. The lower, the better! Keep balances as low as to help your credit soar."
  }
];




